export default {
  checkreturn: {
    searchPlaceholder: '商品名 / 验退单号',
    orderType: '订单性质',
    orderTypeOption: ['一般采购', '委外采购', 'VMI采购'],
    purchaseUnitNo: '采购中心',
    dateRange: '验退日期',
    goodsNo: '料号',
    goodsName: '品名',
    spec: '规格',
    purchaseUnitName: '采购中心',
    checkReturnNo: '验退单号',
    checkReturnDate: '验退日期',
    settleOfficeName: '客户',
    purOfficeName: '采购中心',
    payTermsName: '付款条件',
    txTermsName: '交易条件',
    currencyName: '币种',
    exchangeRate: '汇率',
    invoiceTypeName: '发票类型',
    remarks: '备注',
    checkReturnSeq: '项次',
    checkReturnQty: '验退数量',
    purUnitName: '单位',
    checkReturnReason: '验退原因',
    manual: '手动获取',
    import: '导入',
    purchaseNo: '订单单号',
    purchaseSeq: '订单项次',
    purchasePhaseSeq: '订单项序',
    docDate: '检验日期'
  },
  deliveryschedulesupplier: {
    searchPlaceholder: '品名/订单单号',
    orderType: '订单性质',
    requiredOrderType: '请选择订单性质',
    qtyType: '未交货物资',
    haveGoodsSign: '仅显示有交货日期物资',
    purchaseUnitNo: '采购中心 ',
    requiredPurchaseUnitNo: '请选择采购中心',
    clearDataTip: '更改采购中心会清空所选数据',
    expectArrivalDateRange: '预计交货日期范围',
    goodsNo: '料号',
    goodsName: '品名',
    purchaseUnitName: '采购中心',
    plantNo: '工厂',
    purQty: '订单数量',
    unDeliveryQty: '应交数量',
    deliveryQty: '发货数量',
    receiveQty: '收货数量',
    count: '数量',
    noData: '暂无数据',
    deliverStatus: '发货状态',
    statusText: { '1': '可发货', '2': '部分发货', '3': '已发货', 'X': '异常' },
    beforeAfterDay: '查看前后天数',
    day0: '无',
    day7: '7天',
    day15: '15天',
    day30: '30天',
    rquiredValidDate: '至少选择预计交货日期范围或者查看前后天数',
    supplierNo: '供应商'
  },
  returndetails: {
    searchPlaceholder: '商品名/退货单号',
    docDate: '退货日期',
    returnNo: '退货单号',
    returnSeq: '项次',
    returnQty: '退货数量',
    returnReason: '退货原因'
  },
  acceptancedetails: {
    searchPlaceholder: '商品名/检验单号/订单号',
    inspectNo: '验收单号',
    docDate: '验收日期',
    inspectSeq: '项次-项序-分批序',
    acceptQty: '验收数量'
  }
}
